export default "__VITE_ASSET__KsHNYW27__"